/* eslint-disable @typescript-eslint/no-unused-expressions */
import { tr } from "date-fns/locale";
import { authApi, culturalapi } from "utilities/Axios";

export const getAllUsersForAdmin = () => {
  return authApi.get("/api/user/UsersForAdmin");
};

export const UpdateUserRole = (data: any) => {
  return authApi.post("/api/user/assignrole", data,);
};

export const getRoles = () => {
  return authApi.get("/api/user/UserRoles");
};

export const getAllUsers = () => {
  return authApi.get("/api/user/Users");
};

export const deleteUser = (data: any) => {
  return culturalapi.get("/user/deleteuser" + `?id=${data}`);
};
